import { fetch, post } from '@/utils/axios'

export default {
  // 上传文件
  UploadFile: (data) => {
    return post('/common/upload', data)
  },
  // 获取货币汇率
  getRateList: (params) => {
    return fetch('/common/getRateList', params)
  },
  // 获取系统钱包地址
  getWalletAddressList: (params) => {
    return fetch('/common/getWalletAddressList', params)
  },
  // 获取系统币种网络
  getCurrencyNetworkSetting: (params) => {
    return fetch('/common/getCurrencyNetworkSetting', params)
  },
  // 获取平台配置
  getConfig: (params) => {
    return fetch('/common/getConfig', params)
  },
  // 获取轮播图
  getBannerList: (params) => {
    return fetch('/common/getBannerList', params)
  },
  // 获取内容列表
  getContentList: (params) => {
    return fetch('/base/content/getContentList', params)
  },
  // 获取内容详情
  getContentInfo: (params) => {
    return fetch('/base/content/getContentInfo', params)
  },
  // 获取贷款配置
  getLoanSetting: (params) => {
    return fetch('/common/getLoanSetting', params)
  },
}
